module.exports = __webpack_public_path__ + "img/logoScroll.2098548b.png";